export class UserEmployee {
    userId: number;
    employeeId: number;
    employeeDisplayName: string;
}